import { UPDATE_DEVICE_FLAGS } from '.';

export const updateDeviceFlags = ({ key, state = true }) => ({
  type: UPDATE_DEVICE_FLAGS,
  payload: { [key]: state },
});
